import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import * as api from 'api/methods';

import { useFetch } from 'hooks/useFetch';

import { convertDataToApi } from './CreateTraining.helpers';

import CreateTraining from './CreateTraining';

const CreateTrainingContainer = ({
  open,
  ...restProps
}: { open: any } & Record<string, any>) => {
  const navigate = useNavigate();

  const [createLoading, setCreateLoading] = useState(false);

  const { data: schools } = useFetch(
    {
      defaultData: [],
      fetcher: api.getSchools,
      immediately: false,
      stopRequest: !open,
    },
    null,
    [open],
  );

  const handleCreateClick = async (
    values: any,
    { resetForm }: { resetForm: any },
  ) => {
    setCreateLoading(true);

    try {
      const training = await api.createTraining(convertDataToApi(values));

      resetForm();

      navigate(`/trainings/${training.id}`);
    } catch (error) {
      console.warn(error); // TODO: catch error
    }

    setCreateLoading(false);
  };

  const schoolOptions = schools.map((school: any) => ({
    label: school.name,
    value: school.id,
  }));

  return (
    <CreateTraining
      {...restProps}
      open={open}
      createLoading={createLoading}
      schoolOptions={schoolOptions}
      onCreateClick={handleCreateClick}
    />
  );
};

export default React.memo(CreateTrainingContainer) as any;
